<template>
  <div class="slide-content">
    <div class="resize-body">
      <div class="resize-content" :style="`transform: translate(-50%,-50%) scale(${scaling})`">
        <div class="title-content">
          <img src="../../../assets/image/kjqg/index/kjyr/kjyr-title.png" class="zcqd-title" alt="">
        </div>
        <div class="kjyr-list">

          <div class="kjyr-item" v-for="item in menuList" :key="item.ind" @click="tojxlhList(item)">
            <div class="item-icon"></div> {{item.title}}
          </div>

        </div>
        <div class="more" @click="toMoreList()">查看更多</div>
      </div>
    </div>

  </div>
</template>0
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import services from "../../../assets/js/services.js"
export default {
  props: ["scaling"],
  mounted() {

  },

  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      specialId: services.KJQG_SPECIAL_ID,
      menuList: [
        {
          title: "装备制造大类",
          categoryInd: 1,
        },
        {
          title: "电子与信息大类",
          categoryInd: 2,
        },
        {
          title: "医药卫生大类",
          categoryInd: 3,
        },
        {
          title: "食品药品与粮食大类",
          categoryInd: 4,
        },
        {
          title: "资源环境与安全大类",
          categoryInd: 5,
        },
        {
          title: "交通运输大类",
          categoryInd: 6,
        },
      ],
    }
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin"]),
    toMoreList() {
      this.goAppsDetailsBeforeLogin().then(() => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/zykjyr`,
        });
        window.open(routeUrl.href, "_blank");
      });
    },
    tojxlhList(item) {
      if (item) {
        this.goAppsDetailsBeforeLogin().then(() => {
          let routeUrl = this.$router.resolve({
            path: `/${this.school_code}/kjqg/zykjyr`,
            query: {
              ind: item.categoryInd,
            },
          });
          window.open(routeUrl.href, "_blank");
        });
      }
    },
  },
}
</script>

<style lang="less" scoped>
.slide-content {
  padding-top: 5.16vw;
  background-size: cover;
  background-position: center;
  height: 100%;
  position: relative;
  .resize-body {
    position: relative;
    width: 100%;
    height: 100%;
    .resize-content {
      // height: 100%;
      width: 1920px;
      transform-origin: center center;
      height: 981px;
      position: absolute;
      top: 50%;
      left: 50%;
      // transform: translateX(-50%);
      .title-content {
        // margin: 0 auto;
        text-align: center;
        .zcqd-title {
          max-width: 580px;
          margin-top: 31px;
        }
      }
      .kjyr-list {
        margin-top: 67px;
        display: flex;
        justify-content: center;
        .kjyr-item {
          height: 583px;
          width: 172px;
          background-size: cover;
          background-position: center;
          margin: 0 34px;
          writing-mode: vertical-lr;
          letter-spacing: 5px;
          font-weight: bold;
          font-size: 24px;
          color: #fefeff;
          display: flex;
          align-items: center;
          text-shadow: 0px 0px 6px rgba(0, 0, 0, 0.34);
          padding-top: 85px;
          transition: all 0.3s;
          cursor: pointer;
          .item-icon {
            display: inline-block;
            margin-bottom: 28px;
            width: 20px;
            height: 20px;
            background: #43a3d5;
            border: 1px solid #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            transform: rotate(45deg);
            &::before {
              content: "";
              display: block;
              width: 10px;
              height: 10px;
              background: #ffffff;
            }
          }
          &:hover {
            transform: translateY(-20px);
          }
          &:nth-child(1) {
            background-image: url("../../../assets/image/kjqg/index/kjyr/kjyr-item1.png");
          }
          &:nth-child(2) {
            background-image: url("../../../assets/image/kjqg/index/kjyr/kjyr-item2.png");
            margin-top: 70px;
          }
          &:nth-child(3) {
            background-image: url("../../../assets/image/kjqg/index/kjyr/kjyr-item3.png");
          }
          &:nth-child(4) {
            background-image: url("../../../assets/image/kjqg/index/kjyr/kjyr-item4.png");
            margin-top: 70px;
          }
          &:nth-child(5) {
            background-image: url("../../../assets/image/kjqg/index/kjyr/kjyr-item5.png");
          }
          &:nth-child(6) {
            background-image: url("../../../assets/image/kjqg/index/kjyr/kjyr-item6.png");
            margin-top: 70px;
          }
        }
      }
      .more {
        width: 148px;
        height: 47px;
        line-height: 47px;
        cursor: pointer;
        background-image: url("../../../assets/image/kjqg/index/xskj/more.png");
        background-size: cover;
        font-weight: 400;
        font-size: 16px;
        color: #0c6aef;
        text-align: center;
        margin: 64px auto 0;
      }
    }
  }
}
</style>